export const palette = {
  purple: {
    800: '#2c2265',
    700: '#342b71',
    600: '#3b347c',
    500: '#413b84',
    400: '#5a5795',
    300: '#7474a7',
    200: '#9a9ac0',
    100: '#c1c2da',
    50: '#e6e7f0',
  },
  pink: {
    900: '#47002a',
    800: '#530038',
    700: '#760046',
    600: '#8e0054',
    500: '#b10069',
    300: '#f68ccb',
    200: '#fabfe2',
    100: '#fcd9ee',
    50: '#fef2f9',
  },
  teal: {
    900: '#00322f',
    800: '#00423f',
    700: '#00534f',
    600: '#00645f',
    500: '#007c77',
    300: '#99dbd8',
    200: '#b2e4e2',
    100: '#ccedec',
    50: '#e5f6f5',
  },
  yellow: {
    900: '#3f2c10',
    800: '#64461a',
    700: '#7d5820',
    600: '#af7b2d',
    500: '#e19e3a',
    300: '#fcd08c',
    200: '#fddfb3',
    50: '#fff7ec',
    'illo-icon-outline': '#f48200',
  },
  neutral: {
    black: '#000',
    white: '#fff',
    grey: '#95989a',
    'primary-body': '#444',
    'grey-icons': '#7a7e81',
    'grey-95989a': '#95989a',
    'grey-bbbdbf': '#bbbdbf',
    'grey-d8d8d8': '#d8d8d8',
    'grey-ebebeb': '#ebebeb',
    'grey-f6f7fa': '#f6f7fa',
  },
  brand: {
    pink: '#ec008c',
    yellow: '#fab040',
    purple: '#1f124f',
    purpleDark: '#190c42',
    teal: '#00a69e',
    beige: '#f5f6d6',
    orange: '#f15d2a',
    brown: '#44190A',
    lightPurple: '#cac1e6',
    newPurple: '#5e58f6',
    darkPurple: '#403cab',
    lightestGray: '#ECECEC',
    lightGray: '#aeb9cb',
    gray: '#59616E',
    darkGray: '#212121',
    lightGreen: '#d9feba',
    darkGreen: '#1a3c34',
  },
  ui: {
    success: '#3bb02e',
    successBg: '#ecf7eb',
    error: '#d62020',
    errorBg: '#fceded',
    blue: '#5586ef',
    blueBg: '#d5e7fc',
    warning: '#fac640',
    warningBg: '#fef6e2',
  },
  component: {
    border: '#bbbdbf',
    'background-highlight': '#f6f7fa',
    'background-active': '#b2d4ff',
  },
  'form-field': {
    'text-active-text': '#444',
    'text-placeholder-text': '#bbbdbf',
  },
  transparent: {
    'blue-15': '#5586ef15',
    'black-15': '#00000015',
    'black-50': '#00000050',
  },
} as const

const getTransition =
  (time: number) =>
  (property: string | string[], timingFunction = '') => {
    if (typeof property === 'string') {
      return `${property} ${time}ms${` ${timingFunction}`}`
    }
    return property.reduce(
      (acc, c, i) =>
        `${acc}${c} ${time}ms ${timingFunction}${
          i === property.length - 1 ? '' : ', '
        }`,
      ''
    )
  }

export const transitions = {
  quick: getTransition(200),
  instant: getTransition(60),
}

export const mediaQueries = {
  iphone: 'only screen and (max-width : 500px)',
  mobile: 'only screen and (max-width : 767px)',
  tablet: 'only screen and (min-width : 768px) and (max-width : 1023px)',
  ipadPro: 'only screen and (min-width : 1024px) and (max-width : 1200px)',
  desktop: 'only screen and (min-width : 992px)',
}
